import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-azure",
  "use": "icon-azure-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-azure\"><g fill=\"#0075be\"><path d=\"M34.9 8.3L18.2 22.3 4 46.9 16.7 46.9z\" /><path d=\"M36.7 11.6L30 30.3 43.3 46.9 17.1 51.7 60 51.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol